import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Watermark } from "../components/Botanical";

export default function PolicyPage() {
  const { slug } = useParams();
  const [policy, setPolicy] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/policies/${slug}`).then((r) => setPolicy(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="max-w-3xl mx-auto px-6 py-20 text-center text-[#5E4D5A]">Policy not found.</div>;
  if (!policy) return <div className="max-w-3xl mx-auto px-6 py-20 text-center text-[#5E4D5A]">Loading…</div>;

  // simple markdown-ish paragraph rendering
  const paragraphs = policy.body_md.split(/\n\n+/).map((p, i) => (
    <p key={i} className="text-[#5A433B] leading-relaxed mb-5" dangerouslySetInnerHTML={{ __html: p.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>") }} />
  ));

  return (
    <div className="relative overflow-x-clip">
    <Watermark opacity={0.22} height="h-[240px] sm:h-[280px]" testid="policy-watermark" />
    <div className="relative max-w-3xl mx-auto px-6 py-20" data-testid={`policy-${slug}`}>
      <p className="text-xs uppercase tracking-[0.3em] text-[#5E6B51]">Policy · v{policy.version}</p>
      <h1 className="font-serif text-5xl mt-3 mb-10">{policy.title}</h1>
      <div className="prose prose-stone max-w-none">{paragraphs}</div>
      <p className="mt-16 text-xs text-[#5E4D5A] italic">Draft document — pending legal review.</p>
    </div>
    </div>
  );
}
